import wx from "weixin-js-sdk";
// import { Notify } from "vant";
import service from "../api/authentication/index";
const wxInit = () => {
  service.getJsApiConfig().then((res) => {
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: res.data.appId, // 必填，公众号的唯一标识
      timestamp: res.data.timeStamp, // 必填，生成签名的时间戳
      nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
      signature: res.data.signature, // 必填，签名，见附录1
      jsApiList: ["chooseWXPay", "hideMenuItems", "hideAllNonBaseMenuItem", "hideOptionMenu"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    });
    wx.ready(function () {
      // Notify({ type: "success", message: "微信加载成功" });
      console.log("微信加载成功");
      wx.hideMenuItems({
        menuList: ["menuItem:share:appMessage", "menuItem:share:timeline", "menuItem:share:qq", "menuItem:share:weiboApp", "menuItem:favorite", "menuItem:share:facebook", "menuItem:share:QZone", "menuItem:copyUrl", "menuItem:originPage", "menuItem:openWithQQBrowser", "menuItem:openWithSafari", "menuItem:share:email", "menuItem:share:brand"] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
      })
      wx.hideAllNonBaseMenuItem();
      wx.hideOptionMenu();
    });
    wx.error(function (res) {
      console.log("微信加载失败");
      // Notify({ type: "danger", message: "微信加载失败" });
    });
  });
};
// const wxInit1 = () => {
//   return new Promise((resolve, reject) => {
//     service.getJsApiConfig().then((res) => {
//       wx.config({
//         debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
//         appId: res.data.appId, // 必填，公众号的唯一标识
//         timestamp: res.data.timeStamp, // 必填，生成签名的时间戳
//         nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
//         signature: res.data.signature, // 必填，签名，见附录1
//         jsApiList: ["chooseWXPay", "hideMenuItems", "hideAllNonBaseMenuItem"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
//       });
//       wx.ready(function () {
//         // Notify({ type: "success", message: "微信加载成功" });
//         wx.hideMenuItems({
//           menuList: ["menuItem:share:appMessage", "menuItem:share:timeline", "menuItem:share:qq", "menuItem:share:weiboApp", "menuItem:favorite", "menuItem:share:facebook", "menuItem:share:QZone", "menuItem:copyUrl", "menuItem:originPage", "menuItem:openWithQQBrowser", "menuItem:openWithSafari", "menuItem:share:email", "menuItem:share:brand"] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
//         })
//         wx.hideAllNonBaseMenuItem();
//         resolve();
//       });
//       wx.error(function (res) {
//         // debugger
//         reject(res);
//         // Notify({ type: "danger", message: "微信加载失败" });
//       });
//     });
//   });
// };
const wxPay = (data) => {
  return new Promise((resolve, reject) => {
    wx.chooseWXPay({
      timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
      nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
      package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
      signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
      paySign: data.paySign, // 支付签名
      success: function (res) {
        console.log(res)
        resolve(res);
      },
      fail: function (res) {
        console.log(res)
        reject(res);
      },
      complete: function (res) {
        console.log(res)
        reject(res)
      }
    });
  });
};
export { wxPay, wxInit };
